import {defineStore} from 'pinia'
import {ref} from 'vue';

export const useUserstore = defineStore('user', () => {
    const userInfo = ref({
        token:''
    })

    const getUserInfo = async (result) => {
        userInfo.value = result
        console.log(result,'sss',userInfo)

    }
    return {
        userInfo,
        getUserInfo
    }

},{
    persist:true
})
